export default __webpack_public_path__ + "static/media/ministerio-03.b14b9e49.svg";